import {
  openYidunCaptcha,
  destroyYidunCaptcha,
  CAPTCHA_ID_CONFIG_KEY,
} from '@/utils/yidunCaptcha';

/**
 * 网易易盾行为式验证码（含降级方案）—— 替换原「算数图形验证码」
 *
 * 用法：
 *   mixins: [yidunCaptcha]
 *   // 点「获取验证码」：只做本地校验，然后交给滑块
 *   this.openYidunVerify(this.sendSmsCode);
 *
 * 约定：
 *   - callback(validate) 只在用户滑动通过后、或按配置跳过验证时触发；
 *   - 用户关闭弹框 / 验证失败重试中，都不会触发 callback，页面无需处理取消分支；
 *   - 开关为 0 时跳过验证，validate 传空串。
 *
 * 降级：SDK 自带多域名重试 + 服务故障兜底（连续报错 3 次后用兜底 validate 放行）。
 * 兜底之外的失败（脚本 404、未配业务ID）弹提示，不静默放行。
 */
export default {
  beforeDestroy() {
    // 组件销毁时清场：摘回调 + 销毁实例，避免弹框和回调残留到下一个页面
    destroyYidunCaptcha();
  },
  methods: {
    async openYidunVerify(callback) {
      // 配置在 store 里缓存，只有首次点击才真正请求
      const { toggle, captchaId } = await this.$store
        .dispatch('common/getYidunCaptchaConfig')
        .catch(() => ({ toggle: '', captchaId: '' }));

      // 开关读取失败时默认走验证，安全优先
      if (toggle === '0') {
        callback && callback('');
        return;
      }

      if (!captchaId) {
        // 业务ID 读不到不静默放行，避免绕过验证
        console.error('[yidun captcha] 未取到 ' + CAPTCHA_ID_CONFIG_KEY);
        this.$message({ message: '验证码加载失败，请稍后重试', type: 'warning' });
        return;
      }

      try {
        await openYidunCaptcha({
          captchaId,
          onVerify: (validate) => callback && callback(validate),
        });
      } catch (e) {
        console.error('[yidun captcha]', e);
        this.$message({ message: '验证码加载失败，请稍后重试', type: 'warning' });
      }
    },
  },
};
